//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/NXObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"ClearInspector",1,0],[0,"Name",1,0],[1,"Objects",0,"NXObjectList",0]],[[["objectTags"],"SetObjects",{},1,0],[["numParameterData"],"GetParameterData",{R_:{parameterData:""}},0,0],[["parameterData"],"SetParameterData",{},1,0]],[]];
SPLM.Mechatronics.ObserverBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ObserverBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ObserverBuilder.ParameterData = class{
    constructor(parameterName,physicsObject,physicsPropTag){
        this.parameterName=parameterName;this.physicsObject=physicsObject;this.physicsPropTag=physicsPropTag;}
    get Parametername(){return this.parameterName}
    set Parametername(val){this.parameterName = val}
    get Physicsobject(){return this.physicsObject}
    set Physicsobject(val){this.physicsObject = val}
    get Physicsproptag(){return this.physicsPropTag}
    set Physicsproptag(val){this.physicsPropTag = val}
};

export default SPLM;